import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9455 5C16.0059 5 16.0612 5.03023 16.1015 5.07558L19.9539 9.74645C20.0192 9.81699 20.0142 9.9228 19.9539 9.99334L12.1686 18.932C12.0881 19.0227 11.9423 19.0227 11.8618 18.932L4.07651 9.99334C4.01616 9.9228 4.01616 9.81699 4.07651 9.74645L7.93395 5.07558C7.96915 5.02519 8.0295 5 8.08986 5H15.9455Z",
			stroke: "#2C2C27",
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 10H19.97",
			stroke: "#2C2C27",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99414 5L11.8667 18.932",
			stroke: "#2C2C27",
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0395 5L12.0664 18.932",
			stroke: "#2C2C27",
			strokeMiterlimit: 10
		})
	]
});
export default SvgVip;
